module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lance-input-container"
  }, [_c('label', [_vm._v("Alterar incremento:")]), _vm._v(" "), _c('div', {
    staticClass: "pos-rlt"
  }, [_c('input', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['f3']),
      expression: "['f3']"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.valorFormatado),
      expression: "valorFormatado"
    }, {
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }],
    ref: "input",
    staticClass: "lance-input no-shortkey",
    attrs: {
      "placeholder": "R$ 0,00"
    },
    domProps: {
      "value": (_vm.valorFormatado)
    },
    on: {
      "shortkey": _vm.focusIncrementoManual,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.incremento($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.valorFormatado = $event.target.value
      }
    }
  }), _c('i', {
    staticClass: "shoutcut"
  }, [_vm._v("F3")])]), _vm._v(" "), _c('u-button', {
    staticClass: "lance-btn",
    on: {
      "click": _vm.incremento
    }
  }, [_vm._v("OK")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c9ef110","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/pregao/components/InputAlterarIncremento.vue
// module id = 1492
// module chunks = 17